import  { type GridRowId } from '@mui/x-data-grid-premium';
import  { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import  { type WritableDraft } from 'immer/dist/internal.js';

interface CheckedState {
  checkedPhraseIds: GridRowId[];
}

const initialState: CheckedState = {
  checkedPhraseIds: [],
};

const checkedSlice = createSlice({
  name: 'checked',
  initialState,
  reducers: {
    setCheckedPhraseIds(state: WritableDraft<CheckedState>, action: PayloadAction<GridRowId[]>) {
      state.checkedPhraseIds = action.payload;
    },
  },
});

export const {
  setCheckedPhraseIds,
} = checkedSlice.actions;

export default checkedSlice.reducer;